/**
 * @typedef {import('../../data/Order').default} Order
 * @typedef {import('../../data/store').default} Store
 */

import tingle from 'tingle.js';
import { nextStep } from '../../actions';
import { Order } from "../../data/order";
import { Contact } from "../../data/contact";
import { SVG_LOADING } from '../../svg';
import { GtmDataLayer } from '../../data/gtmDataLayer';

export class WizardSteps {
    /**
     * Component that handles the wizard step.
     * @constructor
     * @param {Object} options
     * @param {Store} options.store
     */
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.translations = options.translations;
        this.$wizard = document.querySelector('.wizard');
        this.store.subscribe(this.update.bind(this));
        this.modal = this.createModal();
        this.currentStepIndex = 0;
        this.buyUrl = window.location.href.indexOf('/nl/exact-online') > 0 ? '/nl/exact-online/wizard?task=buy.execute' : `${this.state.settings.wizard_urls[this.state.product.language]}?task=buy.execute`;
        // this.buyUrl = '/nl/wizard?task=buy.execute';
        this.orderCall = new Order({
            store: this.store,
            url: this.buyUrl,
            data: this.store
        });

        this.contactCall = new Contact({
            store: this.store,
            data: this.store
        });

        this.update();
    }

    submitContact() {
        this.contactCall.submit(this.currentStepIndex);
    }

    submitOrder(token = false) {
        this.modal.setContent(`
${SVG_LOADING}<p>${__('Your payment is being processed')}</p>
        `);
        this.modal.open();
        this.orderCall
            .submit(token)
            .then(data => {
                if (data && data.status === 'success') {
                    setTimeout(() => {
                        this.gtmPusPurchase(data.datalayer);
                        this.gtmPusFormFields();
                        this.submitContact();
                        this.currentStepIndex += 1;
                        this.store.dispatch(nextStep(this.currentStepIndex));
                        if (this.state.product.bouwLink === '1' && data.customer) {
                            this.replaceButton(data.customer);
                        }
                        this.modal.close();
                    }, 100);
                } else if (data && data.status === 'error') {
                    setTimeout(() => {
                        if (data.message.indexOf('Bestaat reeds (Gebruikersnaam)') !== -1 || data.message.indexOf('Already exists (User name)') !== -1) {
                            this.modal.setContent(`
<p style="text-align: left;">${__('Payment failed')}: Error: ${data.message}<br/> ${__('This email address is already used as a username. Choose a unique username.')}</p>
<div class="field field--text">
    <label for="alternativeUserName" class="field-label">${__('Username')}</label>
    <input type="text" id="alternativeUserName" required="" placeholder="" class="field-input form-control field-input--text">
</div>
                                            `);
                            this.modal.addFooterBtn(
                                __('Close'),
                                'tingle-btn tingle-btn--primary username-btn',
                                () => {
                                    this.modal.close();
                                }
                            );
                            this.modal.addFooterBtn(
                                __('Submit'),
                                'tingle-btn tingle-btn--primary username-btn',
                                () => {
                                    // document.getElementById('errorMessage').innerHTML
                                    const username = document.getElementById(
                                        'alternativeUserName'
                                    ).value;
                                    this.modal.setContent(`
${SVG_LOADING}<p>${__('Your payment is being processed')}</p>
                                    `);

                                    const buttons = document.getElementsByClassName(
                                        'username-btn'
                                    );
                                    for (
                                        let i = 0;
                                        i < buttons.length;
                                        i += 1
                                    ) {
                                        buttons[
                                            i
                                        ].style.visibility = 'hidden';
                                    }

                                    this.orderCall
                                        .submitName(username)
                                        .then(response => {
                                            if (
                                                response &&
                                                response.status === 'success'
                                            ) {
                                                setTimeout(() => {
                                                    this.submitContact();
                                                    this.currentStepIndex += 1;
                                                    this.store.dispatch(
                                                        nextStep(
                                                            this.currentStepIndex
                                                        )
                                                    );
                                                    this.gtmPusPurchase();
                                                    this.gtmPusFormFields();
                                                    if (this.state.product.bouwLink === '1' && response.customer) {
                                                        this.replaceButton(response.customer);
                                                    }
                                                    this.modal.close();
                                                }, 100);
                                            } else if (
                                                response &&
                                                response.status === 'error' &&
                                                response.message.indexOf('Bestaat reeds (Gebruikersnaam)') !== -1
                                            ) {
                                                this.modal
                                                    .setContent(`
<p style="text-align: left;">${__('Payment failed')}: Error: ${
    response.message
}<br/>
${__('This email address is already used as a username. Choose a unique username.')}</p>
<div class="field field--text">
    <label for="alternativeUserName" class="field-label">${__('Username')}</label>
    <input type="text" id="alternativeUserName" required="" placeholder="" class="field-input form-control field-input--text">
</div>
                                                        `);

                                                for (
                                                    let i = 0;
                                                    i < buttons.length;
                                                    i += 1
                                                ) {
                                                    buttons[i].style.visibility = '';
                                                }
                                            } else {
                                                this.modal
                                                    .setContent(`
<p style="text-align: left;">${__('Payment failed')}: Error: ${response.message}</p>
                                                        `);
                                                this.modal.addFooterBtn(
                                                    __('Close'),
                                                    'tingle-btn tingle-btn--primary',
                                                    () => {
                                                        this.modal.close();
                                                    }
                                                );
                                            }
                                        });
                                }
                            );
                        } else {
                            this.modal.addFooterBtn(
                                __('Close'),
                                'tingle-btn tingle-btn--primary',
                                () => {
                                    this.modal.close();
                                }
                            );
                            this.modal.setContent(`
<p>${__('Payment failed')}: Error: ${data.message}</p>
                            `);
                        }
                    }, 1000);
                }
            })
            .catch(error => {
                this.modal.addFooterBtn(
                    __('Close'),
                    'tingle-btn tingle-btn--primary',
                    () => {
                        this.modal.close();
                    }
                );
                this.modal.setContent(`
<p>${__('Payment failed')}: Error: ${error}</p>
                `);
            });
    }

    // eslint-disable-next-line class-methods-use-this
    createModal() {
        // eslint-disable-next-line new-cap
        const modal = new tingle.modal({
            closeMethods: [],
            cssClass: ['loader-modal'],
            footer: true,
            beforeClose() {
                this.setFooterContent('');
                // here's goes some logic
                // e.g. save content before closing the modal
                return true; // close the modal
            }
        });

        return modal;
    }

    gtmPusPurchase(datalayer) {
        GtmDataLayer.purchase(this.state, datalayer);
    }

    gtmPusFormFields() {
        GtmDataLayer.formFields(this.state);
    }

    replaceButton(customer) {
        const country = this.state.formFields.find(field => field.id === 'country' ).value;
        let url = `https://login.bouw7.nl?inviteid=00000000-0000-0000-0000-000000000000&accountid=${customer}`;
        url += `&country=${country}`;
        const language = this.state.product.language.split('-')[0];
        url += `&language=${language.toUpperCase()}`;

        const $exactOnlineLink = document.getElementById('thankyou-cta');
        $exactOnlineLink.href = url;
    }

    update() {
        this.state = this.store.getState();
        const currentStep = this.state.steps.find(step => step.current === true);
        const allWizardSteps = Array.from(document.querySelectorAll('.wizard__step'));

        for (const step of allWizardSteps) {
            step.classList.remove('wizard-step--active');
        }

        this.$wizard.setAttribute('data-wizard-step', currentStep.id);
        document
            .getElementById(`wizard_${currentStep.id}`)
            .classList.add('wizard-step--active');
    }
}

export default WizardSteps;
